module.exports = __webpack_public_path__ + "/login_ui/img/za-3aba8a56e52ad0fe15432a35b5b35ee9.svg";